import React from "react";
// import ReactDOM from "react-dom";
import { render } from "react-snapshot";
import "../node_modules/@fortawesome/fontawesome-free/css/all.css";
import "./css/master.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

require("dotenv").config();

render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
